const FOOTER_LINKS = [
  { href: '/#about', label: 'About Us' },
  { href: '/#capabilities', label: 'What We Do' },
  { href: '/#industries', label: 'Our Customers' },
  { href: '/#quality', label: 'Quality' },
  { href: '/#why-us', label: 'Why Us' },
  { href: '/#contact', label: 'Contact Us' },
];

const LEGAL_LINKS = [
  { href: '/privacy-policy', label: 'Privacy Policy' },
  { href: '/terms-and-conditions', label: 'Terms & Conditions' },
];

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row g-4 align-items-start">
          <div className="col-lg-4">
            <a href="/">
              <img src="/logo.png" alt="Bhavani Die Casting Private Limited" className="footer-logo mb-3" />
            </a>
            <p className="footer-muted small mb-0">
              Precision manufacturing with process-first execution.<br />
              ISO 9001 Certified · IATF 16949 Aligned.
            </p>
          </div>
          <div className="col-lg-4">
            <p className="footer-heading small mb-3">Quick Links</p>
            <div className="d-flex flex-wrap gap-3">
              {FOOTER_LINKS.map((l) => (
                <a key={l.href} className="footer-link small" href={l.href}>{l.label}</a>
              ))}
            </div>
          </div>
          <div className="col-lg-4">
            <p className="footer-heading small mb-3">Get in Touch</p>
            <p className="small mb-1">
              <a className="footer-link" href="tel:+919545130777">+91 9545130777</a>
            </p>
            <p className="small mb-1">
              <a className="footer-link" href="tel:+919595909599">+91 9595909599</a>
            </p>
            <p className="small mb-0">
              <a className="footer-link" href="mailto:contact@bhvanidc.com">contact@bhvanidc.com</a>
            </p>
          </div>
        </div>
        <hr className="footer-hr mt-4 mb-3" />
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
          <p className="footer-muted small mb-0">
            © {new Date().getFullYear()} Bhavani Die Casting Private Limited. All rights reserved.
          </p>
          <div className="d-flex flex-wrap gap-3">
            {LEGAL_LINKS.map((l) => (
              <a key={l.href} className="footer-link small" href={l.href}>{l.label}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
